import React from 'react';

const ResultsHeader = () => {
  return (
    <div className="subtitle bigger">
      Once we take project, we deliver
      <div className="extra">
        See how we’ve helped our customers build technological competitive
        advantages.
      </div>
    </div>
  );
};

export default ResultsHeader;
